import React from 'react';
import PropTypes from 'prop-types';
import './index.scss';
import Delay from '../../base/delay';
import Tip from './tip';
import Pulsing from './pulsing';
import { LAYERS } from '../../layers/types';
import * as MainActions from '../../main/actions';
import { getWidgetDisplay } from '../../layers/widget/helpers';
import store from '../../../helpers/store';

import PhoneIcon from '../../../common/icons/phone.svg';
import ChatIcon from '../../../common/icons/chat.svg';
import CMBIcon from '../../../common/icons/document-lines.svg';

class MinimizedFrame extends React.Component {
    constructor(props) {
        super();
        this.refCallback = this.refCallback.bind(this);
        this.state = {
            isVisible: false,
            isTipVisible: false
        };
        this.tipText = this.getTipText(
            props.config && props.config.tipOptions && props.config.tipOptions.tipText
                ? props.config.tipOptions.tipText
                : ''
        );
    }

    getTipText(tipText) {
        const texts = {
            '<p>Masz pytanie?</p><p class=strong>Skorzystaj z pomocy</p>':
                '<p>Masz pytanie?<br/><span class=underline>Skorzystaj z pomocy</span></p>',
            '<p>Chcesz mieć pewność, że składasz zamówienie dobrze? </p><p class=strong>Napisz do nas! </p>':
                '<p>Chcesz mieć pewność, że składasz zamówienie dobrze? <span class=underline>Napisz do nas!</span></p>',
            '<p>Masz problem z logowaniem?</p><p class=strong>Skorzystaj z pomocy.</p>':
                '<p>Masz problem z logowaniem?<br/><span class=underline>Skorzystaj z pomocy</span></p>'
        };

        return texts[tipText] ? texts[tipText] : tipText;
    }

    updateMainLayer(params) {
        MainActions.updateMainLayer({
            layer: LAYERS.WIDGET,
            iFrameMode: getWidgetDisplay(),
            source: 'minimizedFrame',
            width: params && params.width ? params.width : null
        });
    }

    refCallback(element) {
        if (element) {
            this.updateMainLayer();
        }
    }

    onOpen() {
        this.setState({ isVisible: true });
    }

    onClose() {
        this.setState({ isVisible: false });
        this.props.events.close ? this.props.events.close('maximizedCountdownTimeout') : null;
    }

    onTipOpen() {
        this.setState({ isTipVisible: true });

        if (this.tipText.length > 100) {
            const state = store.getState();
            this.updateMainLayer({ width: state.main.device === 'MOBILE' ? 350 : 410 });
        } else if (this.tipText.length > 85) {
            this.updateMainLayer({ width: 370 });
        } else {
            this.updateMainLayer({ width: 310 });
        }
    }

    onTipClose() {
        this.setState({ isTipVisible: false });
        this.updateMainLayer({ width: 120 });
    }

    render() {
        const {
            config,
            icon,
            style,
            events,
            ignoreDelays,
            delays,
            badgeCount,
            children,
            pulseAfter
        } = this.props;
        const classes = 'minimized-frame ' + (style ? style : '');

        let iconObject;
        switch (icon) {
            case 'cmb':
                iconObject = <CMBIcon />;
                break;
            case 'chat':
                iconObject = <ChatIcon />;
                break;
            case 'phone':
                iconObject = <PhoneIcon />;
                break;
            default:
                iconObject = <PhoneIcon />;
                break;
        }

        return (
            <Delay
                showAfter={ignoreDelays ? 0 : delays.showAfter || 0}
                hideAfter={ignoreDelays ? 0 : delays.hideAfter || 0}
                onOpen={() => this.onOpen()}
                onClose={() => this.onClose()}
                sendInviteTimeout={true}
            >
                {this.state.isVisible && (
                    <a
                        href="#"
                        className={classes}
                        ref={this.refCallback}
                        onClick={events.maximize}
                    >
                        {config &&
                            config.tipAvailable &&
                            config.tipOptions &&
                            config.tipOptions.tipText && (
                            <Tip
                                ignoreDelays={ignoreDelays}
                                showAfter={config.tipOptions.showAfter}
                                hideAfter={config.tipOptions.hideAfter}
                                tipText={this.tipText}
                                onOpen={() => this.onTipOpen()}
                                onClose={() => this.onTipClose()}
                            />
                        )}
                        <Pulsing
                            pulseAfter={
                                ignoreDelays
                                    ? []
                                    : (pulseAfter || '-1')
                                        .toString()
                                        .split(',')
                                        .map(Number)
                            }
                        >
                            <div className="minimized-frame--icon-with-badge">
                                {badgeCount !== undefined &&
                                    badgeCount !== null &&
                                    badgeCount !== false && (
                                    <div className="minimized-frame--icon-with-badge--badge">
                                        <p>{badgeCount}</p>
                                    </div>
                                )}
                                <div className="minimized-frame--icon-with-badge--icon">
                                    {iconObject}
                                </div>
                                {children}
                            </div>
                        </Pulsing>
                    </a>
                )}
            </Delay>
        );
    }
}

MinimizedFrame.defaultProps = {
    badgeCount: null,
    ignoreDelays: false,
    delays: {
        showAfter: 0,
        hideAfter: 0
    },
    pulseAfter: '-1'
};

MinimizedFrame.propTypes = {
    config: PropTypes.object,
    icon: PropTypes.string,
    style: PropTypes.string,
    events: PropTypes.object.isRequired,
    ignoreDelays: PropTypes.bool,
    delays: PropTypes.object,
    badgeCount: PropTypes.number,
    pulseAfter: PropTypes.string
};

export default MinimizedFrame;
